import PrintView from './views/PrintView';

import ButtonTooltip from '../../ButtonTooltip';

import Icon from '@map/components/Icons';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
import TabModal from 'views/MapView/components/TabModal';

/**
 * Componente responsável por iniciar configuração da impressão
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Setar o estado
 * @returns Um modal onde é possivel configurar a impressão
 */
export const Print = ({ mapContext, isActive, setIsActive }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const views = [
    {
      title: 'Imprimir',
      Component: (
        <PrintView
          mapContext={mapContext}
          onClose={() => setModalOpen(false)}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div style={{ display: 'flex' }}>
      <ButtonTooltip
        tooltip="Imprimir"
        description="Imprimir mapa."
        onClick={() => {
          setModalOpen(true);
          setIsActive();
        }}
        active={isActive}
      >
        <Icon
          i="map-toolbar-print"
          width="17"
          height="17"
          style={{ verticalAlign: 'middle' }}
        />
      </ButtonTooltip>
      <TabModal
        title="Imprimir"
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setIsActive();
        }}
        views={views}
        sectionWidth={1150}
        sectionHeight={770}
      />
    </div>
  );
};

Print.properties = {
  id: 'CPN-TB-P-PRINT',
  alias: 'Impressão',
  description: 'Ferramenta de configuração da impressão',
};

export default Print;
